import type { SlateBlock } from '@atlas/renderer';
import { Path, Element, Editor } from 'slate';
import matchNodes, { type NodeMatchOptions } from '@atlas/tool/box/slate/matchNodes';

export default function matchBlockNodes<T extends SlateBlock>(editor: Editor, options?: BlockMatchOptions<T>) {
    return matchNodes<T>(editor, {
        ...options,
        match: (node, path) => {
            if (!Element.isElement(node)) return false;
            if (options?.type && node.type !== options.type) return false;
            if (options?.match && !options.match(node, path)) return false;
            return true;
        },
    });
}

// #region Types

export type BlockMatch<T extends SlateBlock> =
    | ((node: SlateBlock, path: Path) => node is T)
    | ((node: SlateBlock, path: Path) => boolean);

export type BlockMatchOptions<T extends SlateBlock> = Omit<NodeMatchOptions<T>, 'match'> & {
    type?: SlateBlock['type'];
    match?: BlockMatch<T>;
};

// #endregion

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('matchBlockNodes', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
